// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { iotex as _iotex } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the iotex chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4689
 * Chain Name: IoTeX
 * Default Block Explorer: https://iotexscan.io
 * Default RPC URL: https://babel-api.mainnet.iotex.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { iotex } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: iotex,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const iotex = createCommon({
	..._iotex,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
